import React from 'react';

const WORDS = ['Community', 'Art', 'Culture', 'Coffee', 'Creativity', 'Pottstown'];

const MarqueeRow = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((word) => (
      <React.Fragment key={word}>
        <span className="font-display px-8 text-3xl font-light italic tracking-tight text-[#f4ede3] sm:text-4xl">
          {word}
        </span>
        <span className="h-2 w-2 rounded-full bg-[#f2a33c]" aria-hidden="true" />
      </React.Fragment>
    ))}
  </div>
);

const Marquee = () => {
  return (
    <div data-testid="editorial-marquee" className="marquee bg-[#14100d] py-6">
      <div className="marquee-track">
        <MarqueeRow />
        <MarqueeRow />
      </div>
    </div>
  );
};

export default Marquee;
